import useSelfServiceRebooking from '../../common/self-service-rebooking/useSelfServiceRebooking';
import { getRebookingData } from './utils/rebooking';
import StartPage from './StartPage';

const StartPageGraphqlContainer = (props) => {
  const {
    loading,
    isSelfServiceRebooking,
    selfServiceRebookingCriteria,
    selfServiceRebookingTravelers,
    selfServiceRebookingValidatingCarriers,
  } = useSelfServiceRebooking();

  if (loading) {
    return null;
  }

  const rebookingData = isSelfServiceRebooking
    ? getRebookingData(
        selfServiceRebookingTravelers,
        selfServiceRebookingCriteria,
        selfServiceRebookingValidatingCarriers,
      )
    : null;
  return <StartPage {...props} rebookingData={rebookingData} />;
};

export default StartPageGraphqlContainer;
